const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        content: cc.Node,
        balanceLabel: cc.Label,
        winAmount: cc.Label,
    },

    start () {
        this.win = 0;
        this.node.active = false;
    },

    updateBalanceLabel (amount) {
        this.balanceLabel.string = i18n.formatCurrency(amount);
    },

    hideBalance() {
        this.balanceLabel.node.active = false;
    },

    updateState () { },

    betIconClicked () {
        this.node.emit('footerBetButtonClicked');
    },

    showWin (amount) {
        this.win = amount;
        this.winAmount.string = i18n.formatCurrency(amount);
    },

    accumulateWin (amount) {
        this.showWin(this.win + amount);
    }
});
